import * as ActionTypes from "../constants/ActionTypes";
import {addItemToCart, queryNewCart} from "./Cart";
import {queryBaseArticle} from "./ArticleData";
import {getActivatedArticle, getSelectedArticle} from "../selectors/ProductSelection";
import {getBaseArticle} from "../selectors/SimpleSelectors";

export const selectCurrentProduct = (articleNumber, selectedAccount = false) => (dispatch, getState) => {

    return dispatch({
        type: ActionTypes.PRODUCT_SET_CURRENT,
        articleNumber: articleNumber,
        selectedAccount: selectedAccount,
    })

}

export const selectBaseArticle = (articleNumber) => (dispatch, getState) => {
    return dispatch({
        type: ActionTypes.BASE_ARTICLE_SELECT,
        articleNumber: articleNumber
    })
}

export const deselectBaseArticle = () => (dispatch, getState) => {

    return dispatch(queryNewCart()).then(args => {
        return dispatch({
            type: ActionTypes.BASE_ARTICLE_DESELECT
        })
    })
}

export const activateBaseArticle = (articleNumber = null, addToCart = false) => (dispatch, getState) => {

    if (!articleNumber) {
        dispatch({
            type: ActionTypes.BASE_ARTICLE_CUSTOM_SELECTED
        })
        return;
    }

    if (articleNumber) {
        dispatch(selectBaseArticle(articleNumber));
    }

    const state = getState();

    const selectedBaseArticle = getSelectedArticle(state)
    const activatedBaseArticle = getActivatedArticle(state)

    const activationPromises = [];

    if (selectedBaseArticle !== activatedBaseArticle) {
        if (!state.articleData.baseArticle || getBaseArticle(state).articleNumber + '' !== selectedBaseArticle) {
            activationPromises.push(queryBaseArticle(selectedBaseArticle));
        }
    }

    return Promise.all(activationPromises.map(func => dispatch(func))).then((args) => {

        if (addToCart) {
            return dispatch(addItemToCart(selectedBaseArticle)).then((args) => {
                return true;
            })
        } else {
            return true;
        }
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/BaseArticle.js
 **/